import { useEffect, useState } from "react";
import { getSettings, subscribe, type Settings } from "./settings";

// Small hook that exposes the current settings snapshot and re-renders
// whenever updateSettings() is called.
export function useSettings(): Settings {
  const [s, setS] = useState<Settings>(getSettings());
  useEffect(() => subscribe(setS), []);
  return s;
}
